import { render, staticRenderFns } from "./ModernTabButton.vue?vue&type=template&id=4557db58&scoped=true&"
import script from "./ModernTabButton.vue?vue&type=script&lang=js&"
export * from "./ModernTabButton.vue?vue&type=script&lang=js&"
import style0 from "./ModernTabButton.vue?vue&type=style&index=0&id=4557db58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557db58",
  null
  
)

export default component.exports